import { Injectable } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { first, switchMap, takeUntil, tap } from 'rxjs/operators';
import { AppEmbedService } from './app-embed.service';
import { AuthService } from './auth.service';
import { DataKlinikDataService } from './data/data-klinik.data.service';
import { IdbStorageService } from './storage/idb-storage.service';
import { storageDict } from './storage/storage-dict';

@Injectable({
  providedIn: 'root',
})
export class AutoRedirectService {
  constructor(
    private authService: AuthService,
    private embedAppService: AppEmbedService,
    private dataKlinikDataService: DataKlinikDataService,
    private router: Router,
    private storageService: IdbStorageService
  ) {}

  private redirectToUrl(url: string) {
    this.router.navigate([`/${url}`], { replaceUrl: true });
  }

  public init() {
    const baseURL = document.location.hostname;

    this.router.events.subscribe((s) => {
      if (s instanceof NavigationStart) {
        const params = new URLSearchParams(s.url.split('#')[1]);
        const redirectId = params.get('redirectId');
        const redirectUrl = params.get('redirectUrl');
        const clinicId = Number(params.get('clinicId'));

        if (redirectId && redirectUrl) {
          this.embedAppService.setEmbedString({ redirectId, redirectUrl });
          this.storageService
            .getItemSync(storageDict.authLocalStorageToken)
            .pipe(
              switchMap((token) => {
                if (clinicId) {
                  return this.authService.signInWithToken({ token: redirectId, clinicId });
                } else {
                  // return get clinic id
                  return this.dataKlinikDataService
                    .getByUrl(baseURL)
                    .pipe(
                      switchMap((clinic) =>
                        this.authService.signInWithToken({ token: redirectId, clinicId: clinic.id })
                      )
                    );
                }
              })
            )
            .subscribe(
              (res) => {
                if (res) {
                  this.redirectToUrl(redirectUrl);
                } else {
                  this.router.navigate([`/error`, `error-3`], { replaceUrl: true });
                }
              },
              async (err) => {
                console.error(err);
                await this.router.navigate([`/error`, `error-3`], { replaceUrl: true });
              }
            );
        }
      }
    });
  }
}
